export default "__VITE_ASSET__SSP5vMxa__"